<template>
  <div class="header-ani" v-show="showHeaderLottie">
    <div class="ani-item" ref="fireworksAni"></div>
    <div class="ani-dragon ani-item" ref="dragon"></div>
    <div class="ani-item cloudStatic"></div>
    <div class="ani-item starStatic"></div>
    <div class="ani-item" ref="yuanAni"></div>
    <!-- <div class="ani-item" ref="ballAni"></div> -->
    <!-- <div class="ani-item ani-dragonTail"></div> -->
    <div class="ani-item ani-mask"></div>
  </div>
</template>

<script>
import lottie from 'lottie-web';

export default {
  data() {
    return {
      fireworksAni: {},
      yuanAni: {},
      dragonAni: {},
      showHeaderLottie: false
    };
  },
  mounted() {
    lottie.setQuality(2);
    this.fireworksAni = lottie.loadAnimation({
      container: this.$refs.fireworksAni,
      renderer: 'svg',
      name: 'name',
      loop: true,
      autoplay: false,
      path: 'https://s3plus.meituan.net/v1/mss_8d74a500df2d46269414be356ca2e522/ecny-package/fireworks-lottie-1228/data.json'
    });
    this.yuanAni = lottie.loadAnimation({
      container: this.$refs.yuanAni,
      renderer: 'svg',
      name: 'name',
      loop: true,
      autoplay: false,
      path: 'https://s3plus.meituan.net/v1/mss_8d74a500df2d46269414be356ca2e522/ecny-package/yuan-lottie-12302/data.json'
    });
    this.dragonAni = lottie.loadAnimation({
      container: this.$refs.dragon,
      renderer: 'svg',
      name: 'name',
      loop: true,
      autoplay: false,
      path: 'https://s3plus.meituan.net/v1/mss_8d74a500df2d46269414be356ca2e522/ecny-package/dragon-1230/data.json'
    });
    this.yuanAni.setSubframe(false);
    this.fireworksAni.setSubframe(false);
    this.dragonAni.setSubframe(false);
    const p2 = this.loadEachAni('fireworksAni');
    const p5 = this.loadEachAni('dragonAni');
    const p7 = this.loadEachAni('yuanAni');
    this.loadComplete([p2, p5, p7]);
  },
  methods: {
    loadEachAni(ani) {
      return new Promise((resolve) => {
        this[ani].addEventListener('data_ready', () => {
          resolve();
        });
      });
    },
    loadComplete(paramsList) {
      Promise.all(paramsList).then(() => {
        this.showHeaderLottie = true;
        this.fireworksAni.play();
        this.yuanAni.play();
        this.dragonAni.play();
      }).catch((err) => {
      });
    },
  }
};
</script>

<style scoped lang="less">
@import "../../../styles/fn.less";
.header-ani {
  position: relative;
  .ani-item {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: -0.9rem;
  }
  .starStatic {
    width: 100vw;
    height: 141vw;
    position: absolute;
    left: 0;
    right: 0;
    top: -0.9rem;
    .bg-image-auto('https://p1.meituan.net/wxapp/9d2eb287d23c1f98746aa0357b66b0e41532.png');
  }
  .cloudStatic {
    width: 100vw;
    height: 141vw;
    position: absolute;
    left: 0;
    right: 0;
    top: -0.9rem;
    .bg-image-auto('https://p1.meituan.net/wxapp/8d035d471001403c1dd6bbfe190a29f142891.png');
  }
  .ani-dragon {
    height: 75.4vw;
    top: 2.35rem;
    .bg-image-auto('https://p0.meituan.net/wxapp/a3cceeade57b7ce6189ddcd6e545a2ca50616.png');
    .ani-dragon-first, .ani-dragon-second {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
    }
  }
  .ani-dragonTail {
    top: 4.85rem;
  }
  .ani-mask {
    top: 8rem;
    width: 100%;
    height: 4rem;
    .bg-image('https://p0.meituan.net/wxapp/af33d5edefd286946d6fd7691a41f5ea16506.png');
  }
}

</style>
